<template>
  <div style="width: 100%;height: 100%; overflow: auto">
    <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
      <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
      <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">基础信息</div>
      <div v-if="showProductForm">
      <frame-form ref="toolProductForm" component-param="tool_product_form" :init-data="toolProductForm"></frame-form>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">软件详情</div>
        <div v-if="showDetail">
          <frame-form ref="toolItemDetail" component-param="tool_product_item_form" :init-data="toolItemDetail"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">历史版本</div>
        <div v-if="showHistory">
          <frame-form ref="toolItemHistory" component-param="tool_product_item_form" :init-data="toolItemHistory"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">功能模块</div>
        <div v-if="showFunction">
          <frame-form ref="toolItemFunction" component-param="tool_product_item_form" :init-data="toolItemFunction"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">价格列表</div>
        <div v-if="showPrice">
          <frame-form ref="toolItemPrice" component-param="tool_product_item_form" :init-data="toolItemPrice"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">相关产品</div>
        <div v-if="showAbout">
          <frame-form ref="toolItemAbout" component-param="tool_product_item_form" :init-data="toolItemAbout"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">业务联络</div>
        <div v-if="showBusiness">
          <frame-form ref="toolItemBusiness" component-param="tool_product_item_form" :init-data="toolItemBusiness"></frame-form>
        </div>
      </div>
    </div>

    <div style="margin-top: 10px;margin-bottom: 20px;text-align: center">
      <el-button style="width: 100px"  type="primary" @click="saveData()" >保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolProductEdit",
  inject: ['$fn'],
  data() {
    return {
      toolProductForm : {},
      toolItemDetail: {},
      toolItemHistory: {},
      toolItemFunction: {},
      toolItemPrice: {},
      toolItemAbout: {},
      toolItemBusiness: {},
      showProductForm:false,
      showDetail:false,
      showHistory:false,
      showFunction:false,
      showPrice:false,
      showAbout:false,
      showBusiness:false,
      updateProductForm:{},
      updateDetail:{},
      updateHistory:{},
      updateFunction:{},
      updatePrice:{},
      updateAbout:{},
      updateBusiness:{}
    }
  },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  async created() {
    await this.loadData();

  },
  methods: {
    async saveData(){
      this.updateProductForm = this.$refs.toolProductForm?.formInfo;
      this.updateDetail = this.$refs.toolItemDetail?.formInfo;
      this.updateHistory = this.$refs.toolItemHistory?.formInfo;
      this.updateFunction = this.$refs.toolItemFunction?.formInfo;
      this.updatePrice = this.$refs.toolItemPrice?.formInfo;
      this.updateAbout = this.$refs.toolItemAbout?.formInfo;
      this.updateBusiness = this.$refs.toolItemBusiness?.formInfo;

      let params = {...this.updateProductForm};
      params.software_detail_image_ids = this.updateDetail.image_ids;
      params.history_image_ids = this.updateHistory.image_ids;
      params.function_image_ids = this.updateFunction.image_ids;
      params.price_image_ids = this.updatePrice.image_ids;
      params.about_product_image_ids = this.updateAbout.image_ids;
      params.business_image_ids = this.updateBusiness.image_ids;
      await this.$http('toolWarehouseService.editToolWarehouse',params);
      this.$fn.closeWindow();
      this.$fn.search();

    },

    async loadData(){
      //找到所有文件
      let fileIds = this.formatFiles(this.parentData);
      let files = await this.getFile(fileIds);

      let parentData = {...this.parentData};
      delete parentData.software_detail_image_ids;
      delete parentData.history_image_ids;
      delete parentData.function_image_ids;
      delete parentData.price_image_ids;
      delete parentData.about_product_image_ids;
      delete parentData.business_image_ids;
      //这个特殊单独写
      if(parentData.detail_image_ids){
        parentData['file@detail_image_ids'] = [];
        let obj = this.findFile(parentData,'detail_image_ids',files,parentData.detail_image_ids);
        parentData['file@detail_image_ids'] = obj['file@image_ids'];
      }
      this.toolProductForm = parentData;
      this.showProductForm = true;
      //下面全部用方法获取
      let data = {...this.parentData};
      this.toolItemDetail = this.findFile(data,'software_detail_image_ids',files,data.software_detail_image_ids);
      this.showDetail = true;
      this.toolItemHistory = this.findFile(data,'history_image_ids',files,data.history_image_ids);
      this.showHistory = true;
      this.toolItemFunction = this.findFile(data,'function_image_ids',files,data.function_image_ids);
      this.showFunction = true;
      this.toolItemPrice = this.findFile(data,'price_image_ids',files,data.price_image_ids);
      this.showPrice = true;
      this.toolItemAbout = this.findFile(data,'about_product_image_ids',files,data.about_product_image_ids);
      this.showAbout = true;
      this.toolItemBusiness = this.findFile(data,'business_image_ids',files,data.business_image_ids);
      this.showBusiness = true;
    },

    formatFiles(data){
      if(!data.detail_image_ids){
        data.detail_image_ids = [];
      }
      if(!data.software_detail_image_ids){
        data.software_detail_image_ids = [];
      }
      if(!data.history_image_ids){
        data.history_image_ids = [];
      }
      if(!data.function_image_ids){
        data.function_image_ids = [];
      }
      if(!data.price_image_ids){
        data.price_image_ids = [];
      }
      if(!data.about_product_image_ids){
        data.about_product_image_ids = [];
      }
      if(!data.business_image_ids){
        data.business_image_ids = [];
      }
      return [...data.detail_image_ids, ...data.software_detail_image_ids, ...data.history_image_ids,
        ...data.function_image_ids, ...data.price_image_ids, ...data.about_product_image_ids, ...data.business_image_ids];
    },

    findFile(data,dataKey,files,imageIds){
      let obj = {};
      let objFiles = []
      if(data[dataKey]){
        for (let imageId of imageIds) {
          for (let file of files){
            if(file.id === imageId){
              objFiles.push(file);
            }
          }
        }
      }
      obj.image_ids = imageIds;
      obj['file@image_ids'] =  objFiles;
      return obj;
    },

    async getFile(fileIds){
      return await this.$http('toolWarehouseService.getFiles',{file_ids:fileIds});
    }

  },
}
</script>

<style scoped>

</style>